module.exports = __webpack_public_path__ + "img/newsImg11-30.dcdc8299.png";